module.exports = __webpack_public_path__ + "img/w41b.78383bdd.jpg";